import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { fetchWithHeaders } from '../../components/Api/Api';
import { getProductLinkFromProduct } from '../../utils/productHelper';
import Loader from '../../components/Loader/Loader';
import ProductNotFound from '../../components/products/ProductNotFound';
import { MdArrowForwardIos } from 'react-icons/md';
import BackButton from '../../components/BackButton';
import ProductDetailsLastSection from '../../components/product-deatils-last/ProductDetailsLastSection';
import { Helmet } from 'react-helmet-async';

export default function ProductRedirect() {
  const navigate = useNavigate();
  const params = useParams();
  const idOrSlug = params.idOrSlug;
  const isNumeric = /^\d+$/.test(idOrSlug);
  const [id, setId] = useState(null);
  const [isNotFound, setIsNotFound] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isNumeric) {
      // C'est un ID, charger les détails du produit

      setId(idOrSlug);
      // Charger les détails du produit ici
    } else {
      // C'est un slug, extraire l'ID et rediriger
      const match = idOrSlug.match(/^(\d+)-/);
      if (match) {
        const idproduct = match[1];
        setId(idproduct);
      } else {
        setIsNotFound(true);
        setLoading(false);
      }
    }
  }, [idOrSlug, navigate]);

  useEffect(() => {
    if (id) {
      fetchWithHeaders(process.env.VITE_API_URL + 'items/' + id)
        .then((product) => {
          console.log(product);
          navigate(getProductLinkFromProduct(product), { replace: true });
        })
        .catch((err) => {
          setIsNotFound(true);
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // Charger les détails du produit avec cet ID
  }, [id]);
  return (
    <>
      <Helmet>
        <title>Page produit - Stop Pièces Auto</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="wrapper">
        <div className="wrapper max-w-[1920px] px-[16px] 1400:px-0 wrapper">
          <div className="content">
            <div className="content flex gap-x-[12px] md:gap-x-[16px] flex-wrap items-center w-full py-[12px] sm:py-[16px] 1400:px-0 px-[16px]">
              <p className="text-dark cursor-pointer transition">
                <Link to="/">Accueil</Link>
              </p>
              <MdArrowForwardIos className="text-[#9EA5A7] text-[12px]" />
              {isNotFound && (
                <p className="text-[#9EA5A7] cursor-pointer transition">
                  Produit introuvable
                </p>
              )}
            </div>
            <BackButton className="mb-[20px] sm:mb-0" />
            {loading && <Loader />}
            {isNotFound && <ProductNotFound />}
          </div>
        </div>
        <ProductDetailsLastSection />
      </div>
    </>
  );
}
